export default "__VITE_ASSET__wvo2cJyA__"